// src/store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  parkpass_token: null,
  parkpass_refresh_token: null,
  permissions: {
    list: [], // Flat list of permissions
    byResource: {}, // Permissions organized by resource
  },
  isAuthenticated: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.info;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.permissions = action.payload.permissions || {
        list: [],
        byResource: {},
      };
      localStorage.setItem("refresh_token", action.payload.refresh_token);
      
      // Handle ParkPass tokens if present
      if (action.payload.parkpass_token) {
        state.parkpass_token = action.payload.parkpass_token;
        localStorage.setItem("parkpass_token", action.payload.parkpass_token);
      }
      if (action.payload.parkpass_refresh_token) {
        state.parkpass_refresh_token = action.payload.parkpass_refresh_token;
        localStorage.setItem("parkpass_refresh_token", action.payload.parkpass_refresh_token);
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.parkpass_token = null;
      state.parkpass_refresh_token = null;
      state.permissions = { list: [], byResource: {} };
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("parkpass_token");
      localStorage.removeItem("parkpass_refresh_token");
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      localStorage.setItem("refresh_token", action.payload);
    },
    setParkPassToken: (state, action) => {
      state.parkpass_token = action.payload;
      localStorage.setItem("parkpass_token", action.payload);
    },
    setParkPassRefreshToken: (state, action) => {
      state.parkpass_refresh_token = action.payload;
      localStorage.setItem("parkpass_refresh_token", action.payload);
    },
    updatePermissions: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const { login, logout, setToken, setRefreshToken, setParkPassToken, setParkPassRefreshToken, updatePermissions } =
  userSlice.actions;

export const selectUser = (state) => state.user.user;
export const selectPermissions = (state) => state.user.permissions;
export const selectParkPassToken = (state) => state.user.parkpass_token;

export const hasPermission = (state, resource, action) => {
  const permissions = state.user.permissions;

  if (
    !permissions ||
    !permissions.byResource ||
    !Array.isArray(permissions.byResource[resource])
  )
    return false;

  return permissions.byResource[resource]?.includes(action) || false;
};

export default userSlice.reducer;